export default "__VITE_ASSET__o0OlCODf__"